(function() {
  'use strict';

  class CardVariantPopup {
    constructor() {
      this.modal = document.getElementById('size-guide-modal');
      this.clickHandler = null;
      this.init();
    }

    init() {
      if (!this.modal) {
        console.warn('Guía de tamaños modal not found');
        return;
      }

      if (this.clickHandler) {
        document.removeEventListener('click', this.clickHandler);
      }

      this.clickHandler = (e) => {
        const button = e.target.closest('.card-variant-popup-btn');
        if (!button) return;

        e.preventDefault();
        e.stopPropagation();

        this.handleButtonClick(button);
      };

      document.addEventListener('click', this.clickHandler);
    }

    destroy() {
      if (this.clickHandler) {
        document.removeEventListener('click', this.clickHandler);
        this.clickHandler = null;
      }
    }

    handleButtonClick(button) {
      const productId = button.dataset.productId;
      const popupType = button.dataset.sizePopupType;
      const sizeSelectTitle = button.dataset.sizeSelectTitle;
      const sizeOptionName = button.dataset.sizeOptionName;

      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) {
        console.warn('Card wrapper not found');
        return;
      }

      const event = new CustomEvent('size-guide:open', {
        detail: {
          popupType,
          sizeSelectTitle,
          sizeOptionName,
          cardContext: true,
          productId,
          cardWrapper,
          button
        },
        bubbles: true
      });

      document.dispatchEvent(event);
    }

  }

  let instance = null;

  function initialize() {
    if (instance) {
      instance.destroy();
    }
    instance = new CardVariantPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);

  document.addEventListener('product-recommendations:loaded', initialize);

})();

